/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentSigningRoleType {
    PARTY = 'PARTY',
    PIV = 'PIV',
    REPRESENTATIVE = 'REPRESENTATIVE',
    COUNTERPARTY = 'COUNTERPARTY',
    WITNESS = 'WITNESS',
    CERTIFIER = 'CERTIFIER',
}
